import React from 'react';
import { observer } from 'mobx-react';

import { staticURL } from 'core/url';

import { withNamespaces } from 'react-i18next';

import { Heading, List, Box, ListItem } from 'components';
import { CadRooms, CloudPdm, OnlinePrototyping, ArrowRight } from 'icons';

import Image from 'components/Image';

import { InfoWrapper } from './signUpInformation.styled';

const SignUpInformation = () => {
  return (
    <>
      <InfoWrapper id='info-wrapper'>
        <Heading size='xlarge'>Sign up for free.</Heading>
        <Heading size='xmedium' weight='regular'>
          And get your product to market faster, with:
        </Heading>
        <Box mb={6} sx={{ marginTop: 70 }}>
          <List
            title='CAD Rooms'
            titleIcon={<CadRooms />}
            icon={<ArrowRight />}
          >
            <ListItem>Unlimited file sharing (IP secure)</ListItem>
            <ListItem>Unlimited invites for collaborators.</ListItem>
            <ListItem>A wide range of collaborative tools.</ListItem>
          </List>
        </Box>
        <Box mb={6}>
          <List
            title='Online Rapid Prototyping'
            titleIcon={<OnlinePrototyping />}
            icon={<ArrowRight />}
          >
            <ListItem>Quotes in 24h.</ListItem>
            <ListItem>Real-time engineering support.</ListItem>
            <ListItem>DfM communication tools.</ListItem>
            <ListItem>RFQ and Order status tracking.</ListItem>
          </List>
        </Box>
        <Box mb={6}>
          <List
            title='Cloud PDM'
            titleIcon={<CloudPdm />}
            icon={<ArrowRight />}
          >
            <ListItem>Unlimited projects (open source or IP secure).</ListItem>
            <ListItem>Unlimited collaborators.</ListItem>
            <ListItem>Unlimited changes and revisions.</ListItem>
            <ListItem>Unlimited teams.</ListItem>
          </List>
        </Box>
        <Image
          src={staticURL('assets/icons/shapes.svg')}
          sx={{
            background: 'transparent',
            right: 0,
            bottom: 0,
            position: 'absolute',
          }}
          alt='Shapes'
        />
      </InfoWrapper>
    </>
  );
};

export default withNamespaces()(observer(SignUpInformation));
